import { generateColumnId } from '../../../utils';
import * as FIELDS from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import { AUDIENCE_BUNDLES_REPORT_ID } from './audienceBundlesReportId';

// columns that can be selectively toggled 'On' and 'Off' in the custom columns view
const customColumns = {
    [REPORT_PRESET.PERFORMANCE]: [
        FIELDS.VISIBLE_IMPRESSIONS.field,
        FIELDS.IMPRESSIONS_PCT.field,
        FIELDS.VCTR.field,
        FIELDS.CLICKS.field,
        FIELDS.AVERAGE_CPC.field,
        FIELDS.VCPM.field,
        FIELDS.SPENT.field,
        FIELDS.CVR.field,
        FIELDS.CONVERSIONS.field,
        FIELDS.CPA.field,
        FIELDS.IMPRESSIONS.field,
        FIELDS.CVR_VS_AVG.field,
        FIELDS.ROAS.field,
    ].map(field => generateColumnId(AUDIENCE_BUNDLES_REPORT_ID, field)),
    [REPORT_PRESET.SETUP]: [FIELDS.ID.field].map(field => generateColumnId(AUDIENCE_BUNDLES_REPORT_ID, field)),
};

const defaultColumns = [
    FIELDS.IS_SELECTED.field,
    FIELDS.AUDIENCE_NAME.field,
    FIELDS.SPENT.field,
    FIELDS.VISIBLE_IMPRESSIONS.field,
    FIELDS.IMPRESSIONS_PCT.field,
    FIELDS.VCTR.field,
    FIELDS.CLICKS.field,
    FIELDS.AVERAGE_CPC.field,
    FIELDS.VCPM.field,
    FIELDS.CVR.field,
    FIELDS.CONVERSIONS.field,
    FIELDS.CPA.field,
    FIELDS.CVR_VS_AVG.field,
].map(field => generateColumnId(AUDIENCE_BUNDLES_REPORT_ID, field));

export { customColumns, defaultColumns };
